module.exports = __webpack_public_path__ + "img/pose-fs-9.e6712768.png";